import React, { useState } from 'react'
import { Button } from "reactstrap"
import { Modal, Progress, Select, Upload } from 'antd'
import { importTracking } from '../../../services/api/apiBarcode'
import { InboxOutlined } from '@ant-design/icons'
import { CSVLink } from 'react-csv'

function ImportTracking() {
    const [modalVisiable, setModalVisiable] = useState(false)
    const [fileError, setFileError] = useState('')
    const [fileList, setFileList] = useState([])
    const [errorRow, setErrorRow] = useState([])
    const [successRow, setSuccessRow] = useState([])
    const [selectedCarrier, setCarrier] = useState({})
    const [overwriteCarrier, setOverwriteCarrier] = useState(false)
    const [loading, setLoading] = useState(false)
    const { Dragger } = Upload

    const handleOpenModal = () => {
        setModalVisiable(!modalVisiable)
    }

    const handleCloseModal = () => {
        setModalVisiable(false)
        setFileList([])
        setSuccessRow([])
        setErrorRow([])
        setFileError('')
        setCarrier({})
        setOverwriteCarrier(false)
    }

    const handleImport = async () => {
        setSuccessRow([])
        setErrorRow([])
        setFileError('')
        setLoading(true)
        try {
            const formData = new FormData()
            formData.append('file', fileList[0])
            formData.append('shipping_carrier', selectedCarrier.value)
            overwriteCarrier && formData.append('overwrite_shipping_carrier', '1')
            const { data: res = {} } = await importTracking(formData)
            const { data = {}, success, message: mess } = { ...res }

            if (!success) {
                throw new Error(mess)
            }
            const { errorRows = [], successRows = [] } = { ...data }
            setErrorRow(errorRows)
            setSuccessRow(successRows)
            setFileList([])
        } catch (error) {
            setFileError(error.message)
        }
        setLoading(false)
    }

    const handleChangeFile = (e) => {
        setFileError('')
        setSuccessRow([])
        setErrorRow([])
        const file = e.file
        if (!!file) {
            const fileListLength = e.fileList.length
            fileListLength ? setFileList([file]) : setFileList([])
        }
    }

    const onChange = (e) => {
        // checkbox
        if (e && e.target) {
            return setOverwriteCarrier(e.target.checked)
        }

        setCarrier(shippingCarriers.find(sc => sc.value === e))
    }

    const shippingCarriers = [
        {
            name: 'Daily Design',
            value: 'dailydesign'
        },
        {
            name: 'LLC USPS',
            value: 'flashship_usps'
        },
        {
            name: 'LLC_manual',
            value: 'flashship_usps_manual'
        },
        {
            name: 'SB CA',
            value: 'sb_ca'
        },
        {
            name: 'SB AU',
            value: 'sb_au'
        },
        {
            name: 'ITC Standard',
            value: 'ge_dhl'
        },
    ]
    const isFinished = loading || successRow.length > 0 || errorRow.length > 0

    const csvData = [
        ["tracking", "barcode", "carrier", "storename"],
        ["", "", "", ""]
    ]

    return (
        <div className='ImportTracking'>
            <Button className="btn-labeled btn-labeled-left ml-1" onClick={handleOpenModal} color="primary">
                <b><i className="icon-barcode2" /></b>
                Import Tracking
            </Button>
            <Modal
                className="ModalImportTracking"
                visible={modalVisiable}
                okText='Import'
                title='Import Tracking'
                onCancel={handleCloseModal}
                onOk={handleImport}
                okButtonProps={{ disabled: !selectedCarrier || !selectedCarrier.name || !fileList || !fileList.length }}
            >
                <label className="ShippingCarrier mb-2">
                    <strong>Shipping carrier:</strong>
                    <Select
                        disabled={isFinished}
                        value={selectedCarrier && selectedCarrier.value || []}
                        onChange={onChange}
                        style={{ minWidth: 150 }}
                        placeholder='--Select carrier--'
                        allowClear
                    >
                        {
                            shippingCarriers.map(carrier => {
                                return <Select.Option key={carrier.value}
                                    value={carrier.value}>{carrier.name}</Select.Option>
                            })
                        }
                    </Select>
                </label>
                {
                    selectedCarrier && selectedCarrier.name &&
                    <p className="OverwriteCarrier text-muted">
                        <label>
                            Ghi đè nếu đơn đã có shipping carrier khác <strong>{selectedCarrier.name}</strong>?
                            <input type="checkbox" onChange={onChange} disabled={isFinished} />
                        </label>
                    </p>
                }
                <Dragger
                    accept='text/csv'
                    multiple={false}
                    beforeUpload={() => {
                        return false
                    }}
                    onRemove={
                        file => {
                            const index = fileList.indexOf(file)
                            const newFileList = fileList.slice()
                            newFileList.splice(index, 1)
                            setFileList(newFileList)
                        }
                    }
                    fileList={fileList || []}
                    onChange={handleChangeFile}
                    listType='picture'
                >

                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Only file csv
                    </p>
                </Dragger>
                <div className='w-100'>
                    <strong>Template import:</strong>
                    <CSVLink
                        data={csvData}
                        filename={`import-tracking.csv`}
                        className="btn btn-link"
                    >
                        <i className="fa fa-download mx-1" />
                        import-tracking.csv
                    </CSVLink>
                </div>
                {fileError && <small className='text-danger justify-content-end'>{fileError}</small>}
                {(successRow.length > 0 || errorRow.length > 0) &&
                    <>
                        <h6 className='mt-3'>Rows check: <b>{successRow.length + errorRow.length}</b> rows</h6>
                        <label>
                            <b className='text-success'>Success:</b> {successRow.length}
                            <b className='text-danger ml-3'>Errors:</b> {errorRow.length}
                        </label>
                    </>
                }
                {
                    !!errorRow.length && errorRow.map(i => (
                        <div>
                            <small className='text-danger'>{i.barcode} - {i.error}</small>
                            <Progress percent={100} status="exception" />
                        </div>
                    ))
                }
                {
                    successRow.length > 0 && successRow.length === (successRow.length + errorRow.length) &&
                    <div>
                        <small className='text-success'>All rows - Success </small>
                        <Progress percent={100} />
                    </div>
                }
            </Modal>
        </div>
    )
}

export default ImportTracking